import React, { Component } from 'react';

import { Edit } from 'components/detail';
import { maxLength, SimpleForm } from 'components/form';
import { HiddenInput, NumberInput, SelectInput, TextInput } from 'components/input';
import { connect } from 'react-redux';
import { change as changeAction } from 'redux-form';
import { FileInput } from 'components/input';
import { Card, CardText } from 'material-ui/Card';
import ViewTitle from 'components/layout/ViewTitle';
import { FileField } from 'components/field/FileField';
import { ClickEventButton } from "components/button/ClickEventButton";
import { crudGetList as crudGetListAction } from 'actions/dataActions';
import { crudCreate as crudCreateAction } from 'actions/dataActions';
import { DisabledInputOptions, InputOptions, RECORD_FORM } from 'util/constants';
import { saveAs } from 'file-saver';

import * as urls from './urls';
import * as utils from './utils';
import PropTypes from "prop-types";
import DefaultActions from 'components/detail/CreateActions';

class MachineLendingExtendBase extends Component {
  state = {
    'bank_payment': false
  };

  componentDidMount() {
    this.props.crudGetList(
      utils.ProductResourceName,
      urls.productBackendPath,
      {
        category: utils.POS_MALL_CATEGORY_MACHINE_LENDING,
        enabled: true,
      }
    );
  }


  paymentTypeOnChange = (_, value) => {
    this.props.change(RECORD_FORM, 'payment_type', value);
    if (value === utils.PAYMENT_TYPE_BANK) {
      this.props.change(RECORD_FORM, 'reason', utils.EXTENSION_TYPE_BANK);
      this.setState({ 'bank_payment': true });
    }
    else {
      this.setState({ 'bank_payment': false });
    }

  };

  itemOnChange = (_, value) => {
    const item = this.props.items[value];

    this.props.change(RECORD_FORM, 'unit_price', item.price);
    this.props.change(RECORD_FORM, 'item_name', item.translation);
    this.props.change(RECORD_FORM, 'price_name', item.price_translation);
    this.props.change(RECORD_FORM, 'item_price_id', item.item_price_id);
  };

  render() {
    const { items } = this.props;
    const { bank_payment } = this.state;
    const itemChoices = Object.values(items).sort((a, b) => a['denomination'] - b['denomination'])
      .filter(item => item.price)
      .map(item => ({
        id: item.id, name: item.translation
      }));
    return (
      <Edit
        editBackendPath={urls.machineLendingExtendBackendPath}
        updateDataOnMount={false}
        {...this.props}>
        <SimpleForm>
          <NumberInput
            source='shop_id'
            label='Shop ID'
            isRequired={true}
            options={DisabledInputOptions}
          />
          <TextInput
            source='sn'
            label='Serial Number'
            isRequired={true}
            options={DisabledInputOptions}/>
          <SelectInput
            source='payment_type'
            label='Payment Type'
            choices={utils.PAYMENT_TYPE_CHOICES}
            onChange={this.paymentTypeOnChange}
            isRequired={true}
            options={InputOptions}/>
          <SelectInput
            source='item_id'
            label='Plans'
            choices={itemChoices}
            onChange={this.itemOnChange}
            isRequired={true}
            options={InputOptions}
          />
          <SelectInput
            source='reason'
            label='Reason'
            isRequired={true}
            choices={utils.EXTENSION_CHOICES}
            options={InputOptions}
          />
          <TextInput
            source='bank_name'
            label='Bank Name'
            isRequired={bank_payment}
            options={bank_payment ? InputOptions : DisabledInputOptions}/>
          <TextInput
            source='bank_ref_no'
            label='Bank Ref No'
            isRequired={bank_payment}
            validators={[maxLength(20)]}
            options={bank_payment ? InputOptions : DisabledInputOptions}/>
          <TextInput
            source='comment'
            label='Comment'
            isRequired={true}
            options={InputOptions}/>
          <HiddenInput source='unit_price'/>
          <HiddenInput source='item_name'/>
          <HiddenInput source='price_name'/>
          <HiddenInput source='item_price_id'/>
        </SimpleForm>
      </Edit>
    )
  }
}

const mapStateToProps = (state, props) => {
  const resourceState = state.admin[utils.ProductResourceName];
  return {
    items: resourceState.data,
    isLoading: state.admin.loading > 0,
  };
};

export const MachineLendingExtend = connect(
  mapStateToProps,
  {
    crudGetList: crudGetListAction,
    change: changeAction,
  }
)(MachineLendingExtendBase);


class MachineLendingBatchExtentBase extends Component {
  static propTypes = {
    actions: PropTypes.element,
    crudCreate: PropTypes.func,
    crudGetOne: PropTypes.func,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    editBackendPath: PropTypes.string,
    redirectPath: PropTypes.string,
    updateDataOnMount: PropTypes.bool,
  };

  static defaultProps = {
    updateDataOnMount: true
  };

  constructor(props) {
    super(props);

    this.state = {
      file: '',
      description: '',
    }
  }

  onChange(file) {
    if (file === null) {
      this.setState({
        file: '',
        description: this.state.description,
      });
    }
    else {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onloadend = () => {
        this.setState({
          file: reader.result,
          description: this.state.description,
        });
      };
    }
  }

  getBasePath() {
    const { location } = this.props;
    return location.pathname.split('/').slice(0, -1).join('/');
  }

  getBatchData() {
    return {
      'file_data': this.state.file,
      'description': this.state.description,
    }
  }

  onDescriptionChange(event) {
    this.setState({
      file: this.state.file,
      description: event.target.value,
    });
  }

  onBatchExtent() {
    this.props.crudCreate(
      utils.ProductResourceName,
      this.getBatchData(),
      urls.machineLendingBatchExtentBackendPath,
      this.getBasePath()
    );
  }

  onDownloadSample() {
    const file = new File(["shop_id,serial,device_type,payment_type,plan\r\n14,sn456,2,1,3"], "sample.csv", { type: "text/csv;charset=utf-8" });
    saveAs(file);
  }

  render() {
    const { actions = <DefaultActions/>, resource } = this.props;
    const basePath = this.getBasePath();

    return (
      <Card>
        {actions && React.cloneElement(actions, {
          basePath,
          resource,
        })}
        <ViewTitle title='Machine Lending - Batch extent'/>
        <CardText>Please upload a csv file with format as sample for batch extention</CardText>
        <ClickEventButton onClick={(event) => this.onDownloadSample()} label='Sample'/>
        <SimpleForm toolbar={null}>
          <FileInput source='files' label='Select File' input={this}
                     placeholder={<p><b>Drag & Drop</b><br/> or <a><i>browse your file</i></a></p>}>
            <FileField source='src' title='title'/>
          </FileInput>
          <TextInput label="Description" onChange={(event) => this.onDescriptionChange(event)}/>
        </SimpleForm>
        <ClickEventButton onClick={(event) => this.onBatchExtent()} label='Batch extent'/>
      </Card>
    )
  }
}

export const MachineLendingBatchExtent = connect(
  (state, props) => state,
  {
    crudCreate: crudCreateAction,
  }
)(MachineLendingBatchExtentBase);



// WEBPACK FOOTER //
// ./src/routes/product/MachineLendingEdit.js